import React from "react";

import "./footer.styles.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      Created by <a href="https://joescript.io">Joe</a>
    </div>
  );
};

export default Footer;
